import { TextVariants } from '@lichtblick/theme';
import { ButtonSize, ButtonVariant } from '@lichtblick/types';

import { BaseButton, Spinner } from './Button.styles';

import { Text } from '../Text';

type ButtonProps = {
  icon?: React.ReactElement;
  isDisabled?: boolean;
  isLoading?: boolean;
  isParentSize?: boolean;
  label: string;
  onClick?: (input?: React.MouseEvent<HTMLElement>) => void;
  size?: ButtonSize;
  variant?: ButtonVariant;
};

export const Button = ({
  icon,
  isDisabled = false,
  isLoading = false,
  isParentSize,
  label,
  onClick,
  size = 'large',
  variant = 'primary',
}: ButtonProps) => (
  <BaseButton
    $isLoading={isLoading}
    $isParentSize={isParentSize}
    $size={size}
    $variant={variant}
    aria-busy={isLoading || undefined}
    disabled={isDisabled || isLoading}
    onClick={onClick}
  >
    {isLoading ? <Spinner aria-hidden="true" /> : icon}
    <Text $variant={size === 'large' ? TextVariants.button.m : TextVariants.button.s}>{label}</Text>
  </BaseButton>
);
